import React from 'react';
import {ScrollView, View} from 'react-native';
import {observer} from 'mobx-react-lite';

import SafeAreaPadding from '../../components/SafeAreaPadding';
import Button from '../../components/themed/Button';
import Text from '../../components/themed/Text';
import ContentView from '../../components/ui-controls/layout/ContentView';
import CelebrationIcon from '../../images/brand/svg/icons/Celebration.svg';
import {AppRoute} from '../../models/AppRoute';
import {RouteNavigatorScreenProps} from '../../models/navigationTypes';
import {navigate} from '../../navigation/RootNavigation';
import {useStores} from '../../stores/use-stores';

const RewardsFullSuccessScreen = observer(
  ({_navigation}: RouteNavigatorScreenProps<AppRoute.REWARDS_FULL_SUCCESS>) => {
    const {userStore} = useStores();

    const handleSignIn = () => {
      // DIS-1628: After full sign-up, send user to sign-in with post-login return to rewards.
      userStore.setPostLoginReturnToScreen(
        AppRoute.ROOT as never,
        {screen: AppRoute.MAIN, params: {screen: AppRoute.ACCOUNT_REWARDS}} as never,
      );
      navigate(AppRoute.ROOT, {
        screen: AppRoute.MAIN,
        params: {screen: AppRoute.ACCOUNT_NOT_LOGGED_IN},
      });
    };

    return (
      <ScrollView style={{backgroundColor: 'white'}}>
        <ContentView>
          <View
            style={{
              padding: 20,
              alignItems: 'center',
              justifyContent: 'center',
            }}>
            <CelebrationIcon width={113} height={115} />
          </View>
          <Text variant="heading1">Congrats!</Text>
          <Text variant="body2">
            Your account and rewards card is ready to go! Start shopping online now or see what’s on
            sale now for members by signing in below with your credentials
          </Text>
          <View style={{gap: 8, marginTop: 40}}>
            <Button secondary title={'SIGN IN / SIGN UP'} onPress={handleSignIn} />
          </View>
          {/* DIS-1628: the rewards flow is a ROOT sibling of DrawerNavigator, so no
              ancestor applies the bottom inset — without this the CTA sits behind the
              Android system nav bar and the iOS home indicator. */}
          <SafeAreaPadding bottom />
        </ContentView>
      </ScrollView>
    );
  },
);

export default RewardsFullSuccessScreen;
